import React, { useState } from 'react';
import { API_URL } from '../config';

function Login({ onLoginSuccess, onBack }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      if (!response.ok) throw new Error('Email o contraseña incorrectos');

      const data = await response.json();
      onLoginSuccess(data.usuario, data.token);
    } catch (err) {
      setError(err.message);
    }
    setCargando(false);
  };

  return (
    <div style={{minHeight: '100vh', backgroundColor: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'}}>
      <button onClick={onBack} style={{position: 'absolute', top: '20px', left: '20px', padding: '10px 20px', backgroundColor: '#f0f2f5', color: '#172b4d', border: '1px solid #ddd', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '14px'}}>
        ← Volver
      </button>

      <div style={{backgroundColor: 'white', padding: '48px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', maxWidth: '400px', width: '100%'}}>
        <div style={{textAlign: 'center', marginBottom: '32px'}}>
          <div style={{fontSize: '48px', marginBottom: '16px'}}>🎈</div>
          <h1 style={{fontSize: '28px', fontWeight: '700', color: '#172b4d', margin: '0 0 8px 0'}}>Sonrie Globos CRM</h1>
          <p style={{fontSize: '14px', color: '#626f86', margin: 0}}>Accede a tu panel de control</p>
        </div>

        {error && <div style={{backgroundColor: '#ffebee', color: '#d32f2f', padding: '12px 16px', borderRadius: '4px', marginBottom: '20px', fontSize: '13px'}}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{marginBottom: '16px'}}>
            <label style={{display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#172b4d'}}>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={{width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box'}} />
          </div>

          <div style={{marginBottom: '24px'}}>
            <label style={{display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#172b4d'}}>Contraseña</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required style={{width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box'}} />
          </div>

          <button type="submit" disabled={cargando} style={{width: '100%', padding: '12px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: '600', fontSize: '14px', opacity: cargando ? 0.7 : 1}}>
            {cargando ? 'Cargando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
